import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSquareArrowUpRight } from '@fortawesome/pro-regular-svg-icons';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { LocalizationState } from '@wilson/localization';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

@Component({
  selector: 'wilson-handbook-info-icon',
  standalone: true,
  imports: [FontAwesomeModule, NzPopoverModule],
  templateUrl: './handbook-info-icon.component.html',
  styleUrl: './handbook-info-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HandbookInfoIconComponent {
  private readonly translateService = inject(TranslateService);
  private readonly store = inject(Store);

  readonly title = input<string>();
  readonly content = input.required<string>();
  readonly linkUrl = input<string>();
  readonly linkText = input<string>(
    this.translateService.instant('general.handbook'),
  );
  readonly placement = input<string>('top');

  protected readonly faInfoCircle = faInfoCircle;
  protected readonly faSquareArrowUpRight = faSquareArrowUpRight;

  protected readonly popoverOverlayStyle = {
    width: '20rem',
    maxWidth: '20rem',
  };

  protected readonly resolvedLinkUrl = computed<string | null>(() => {
    const url = this.linkUrl();
    if (!url) return null;
    return url.replace(
      '{lang}',
      this.store.selectSnapshot(LocalizationState.getBackendLang),
    );
  });
}
